import {
  selectFiscalCapitalBalanceList,
  selectFiscalCapitalBalanceListCount,
  selectFiscalCapitalBalanceQueryOptions,
  selectFiscalCapitalBalanceSummaryList,
  selectFiscalCapitalBalanceSummaryCount,
  selectAccountingCapitalBalanceList,
  selectAccountingCapitalBalanceListCount,
  selectAccountingCapitalBalanceQueryOptions,
  selectAccountingCapitalBalanceSummaryList,
  selectAccountingCapitalBalanceSummaryCount
} from 'src/store/selectors/capitalBalanceSelectors';
import {
  loadFiscalCapitalBalance,
  LOAD_FISCAL_CAPITAL_BALANCE,
  LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  CLEAR_FISCAL_CAPITAL_BALANCE,
  downloadExcelFiscalCapitalBalance,
  loadFiscalCapitalBalanceSummary,
  loadAccountingCapitalBalance,
  LOAD_ACCOUNTING_CAPITAL_BALANCE,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  downloadExcelAccountingCapitalBalance,
  loadAccountingCapitalBalanceSummary
} from 'src/store/actions/capitalBalanceActions';

export const FISCAL_CAPITAL_BALANCE_CONFIG = {
  selectors: {
    selectList: selectFiscalCapitalBalanceList,
    selectCount: selectFiscalCapitalBalanceListCount,
    selectQueryOptions: selectFiscalCapitalBalanceQueryOptions,
    selectSummaryList: selectFiscalCapitalBalanceSummaryList,
    selectSummaryCount: selectFiscalCapitalBalanceSummaryCount
  },
  actions: {
    load: loadFiscalCapitalBalance,
    loadSummary: loadFiscalCapitalBalanceSummary,
    downloadExcel: downloadExcelFiscalCapitalBalance
  },
  loadActionType: LOAD_FISCAL_CAPITAL_BALANCE,
  loadSummaryActionType: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  clearActionType: CLEAR_FISCAL_CAPITAL_BALANCE,
  titleKey: 'NAVIGATION.FISCAL_CAPITAL_BALANCE',
  summaryTitleKey: 'NAVIGATION.FISCAL_CAPITAL_BALANCE_SUMMARY',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};

export const ACCOUNTING_CAPITAL_BALANCE_CONFIG = {
  selectors: {
    selectList: selectAccountingCapitalBalanceList,
    selectCount: selectAccountingCapitalBalanceListCount,
    selectQueryOptions: selectAccountingCapitalBalanceQueryOptions,
    selectSummaryList: selectAccountingCapitalBalanceSummaryList,
    selectSummaryCount: selectAccountingCapitalBalanceSummaryCount
  },
  actions: {
    load: loadAccountingCapitalBalance,
    loadSummary: loadAccountingCapitalBalanceSummary,
    downloadExcel: downloadExcelAccountingCapitalBalance
  },
  loadActionType: LOAD_ACCOUNTING_CAPITAL_BALANCE,
  loadSummaryActionType: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  clearActionType: CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  titleKey: 'NAVIGATION.ACCOUNTING_CAPITAL_BALANCE',
  summaryTitleKey: 'NAVIGATION.ACCOUNTING_CAPITAL_BALANCE_SUMMARY',
  notFoundTitle: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_TITLE',
  notFoundDescription: 'NOT_FOUND_RECORDS_MESSAGE.BALANCE_CAPITAL_DESCRIPTION'
};
